import React, { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import BannerSingle from '../../BannerSingle';
import Lgpd from '../../Lgpd';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import ViverNoticias from '../../ViverMelhor/ViverNoticias';
import "../../Pages/ViverMelhor/styles.css";
import ViverCalendario from '../../ViverMelhor/ViverCalendario';
import ViverMelhorExtraPageLayout from '../../ViverMelhor/ViverMelhorExtraPageLayout';
import CustomPageDescription from '../../PageDescription/CustomPageDescription';
import Helper from "../../Helper";

interface ComponentProps {
	page?: string;
}

interface ComponentState {
	isLoaded: boolean;
	result: any[];
}

class ViverMelhorPage extends Component<ComponentProps, ComponentState> {

	private helper: Helper;

	constructor(props: ComponentProps) {
		super(props);
		this.state = {
			isLoaded: false,
			result: []
		};
		this.helper = new Helper(this);
	}

	componentDidMount() {
		this.helper.init('viver-melhor');
	}

	componentDidUpdate(prevProps: ComponentProps, prevState: ComponentState) {
		if (this.state.result.length > 0 && prevState.result !== this.state.result) {
			document.title = this.state.result[0]?.Title;
		}
	}

	render() {

		return (

			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<ErrorBoundary><BannerSingle page={"viver-melhor"} image={"viver-melhor"} items={this.state.result}/></ErrorBoundary>

				{/* Page description */}
				<ErrorBoundary>
					<CustomPageDescription page={"viver-melhor"} items={this.state.result}/>
				</ErrorBoundary>
				{/* Content page */}				
				<br></br>
				{/* EVENTOS */}
				<div className='container'>

					{/* NOTICIAS */}
					<div className='row justify-content-center'>
						<div className="col-lg-10 col-xl-10">
							<div className="page-description__title"><h4>Notícias do Programa</h4></div>
							<div>
								<ErrorBoundary>
									<ViverNoticias />
								</ErrorBoundary>
							</div>
						</div>
					</div>

					{/* <br></br>	<br></br><br></br><br></br> */}
					{/* <br></br> */}

					<div className='row justify-content-center '>
						<div className="col-lg-10 col-xl-10 section-page">
							<div className="page-description__title mb-lg-5"><h4>Eventos</h4></div>
							<div>Fique por dentro de nossa programação.</div>
							<div>
								<ErrorBoundary>
									<ViverCalendario></ViverCalendario>
								</ErrorBoundary>
							</div>
						</div>
					</div>

					{/* <br></br><br></br><br></br><br></br> */}
					<br></br><br></br>



					<ViverMelhorExtraPageLayout page={"viver-melhor"} items={this.state.result}></ViverMelhorExtraPageLayout>

				</div>

				<br></br>	<br></br>

				{/*  <ScrollInfinito/> */}
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default ViverMelhorPage;